import styled from '@emotion/styled';
import { colors } from '@libs/ui';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import { dateToStr, labelName, useItemNames, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router';
import { HeaderControlGroupItem } from '../components/HeaderControlGroup';
import { useProcessingMonth } from '../context';

const Button = styled(HeaderControlGroupItem)`
  flex-shrink: 0;
  padding: 0 10px;
`;

/** 処理月度を出し、押すと締め状況確認へ遷移する。{@link HeaderControlGroup} に収める。 */
function ProcessingMonthLink() {
  const getLabelName = useItemNames(labelName);
  const { processingMonth } = useProcessingMonth();
  const { dateFormat } = useLocalizedContents();
  const navigate = useNavigate();

  return (
    <Button
      id="global-processing-month-label"
      type="button"
      title={getLabelName('processingMonth')}
      onClick={() => navigate('/fa/confirm-settlement-status')}
    >
      <CalendarMonthOutlined sx={{ fontSize: '14px', color: colors.txtBlack }} />
      {dateToStr(processingMonth, dateFormat.ym)}
    </Button>
  );
}

export { ProcessingMonthLink };
